import type { ConceptDef } from '../types';

export const tactShops: ConceptDef = {
  kind: 'supervisorScored',
  id: 'tact-shops',
  label: 'Expressive Shops',
  category: 'Expressive',
  description: 'Show a shop; learner names it. Supervisor scores.',
  config: {
    promptMode: 'TEXT',
    prompts: [
      { prompt: '🍞 bakery' },
      { prompt: '🥩 butcher' },
      { prompt: '💊 pharmacy' },
      { prompt: '🛒 supermarket' },
      { prompt: '💐 florist' },
      { prompt: '📚 bookshop' },
      { prompt: '🧸 toy shop' },
      { prompt: '✂ hairdresser' },
    ],
  },
};
